module.exports = __webpack_public_path__ + "img/DE00159.0bdff974.png";